import { LevelDesignerComponent } from "../../level-designer/level-designer.component";
import { PropertyEditor } from "../property-editor";
import { PropertyMetadata } from '../property-types';

export class MultipleValues {
    toString() {
        return '<Multiple Values>';
    }
}

export abstract class PropertyInput {
    protected ctx: CanvasRenderingContext2D;
    protected x: number;
    public y: number;
    protected width: number;
    protected height: number;
    protected value: any;
    protected displayValue: string = "";
    public isActive: boolean;
    protected levelDesigner: LevelDesignerComponent;
    protected propertyEditor: PropertyEditor;
    public idProperty: string = "";
    public labelProperty: string = "";
    public metadata!: PropertyMetadata;

    constructor(
        ctx: CanvasRenderingContext2D,
        x: number,
        y: number,
        width: number,
        height: number,
        value: any,
        isActive: boolean,
        levelDesigner: LevelDesignerComponent,
        propertyEditor: PropertyEditor
    ) {
        this.ctx = ctx;
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.setValue(value);
        this.isActive = isActive;
        this.levelDesigner = levelDesigner;
        this.propertyEditor = propertyEditor;
    }

    abstract draw(): void;
    abstract handleClick(x: number, y: number): boolean;
    abstract handleKeyEvent(event: KeyboardEvent): boolean;
    abstract focus(): void;
    abstract blur(): void;

    public handleMouseMove(x: number, y: number): boolean {
        return false;
    }

    public handleMouseUp(x: number, y: number): boolean {
        return false;
    }

    public setValue(value: any): void {
        if(!(value instanceof MultipleValues)) {
            this.value = value;
        }
        this.displayValue = value?.toString() || "";
    }

    public getValue(): any {
        return this.value;
    }

    protected roundRect() {
        this.ctx.beginPath();
        this.ctx.moveTo(this.x + 4, this.y);
        this.ctx.arcTo(this.x + this.width, this.y, this.x + this.width, this.y + this.height, 4);
        this.ctx.arcTo(this.x + this.width, this.y + this.height, this.x, this.y + this.height, 4);
        this.ctx.arcTo(this.x, this.y + this.height, this.x, this.y, 4);
        this.ctx.arcTo(this.x, this.y, this.x + this.width, this.y, 4);
        this.ctx.closePath();
    }

    protected drawBackground() {
        this.ctx.fillStyle = '#FFFFFF';
        this.ctx.strokeStyle = this.isActive ? '#0078D7' : '#CCCCCC';
        this.ctx.lineWidth = this.isActive ? 2 : 1;
        this.roundRect();
        this.ctx.fill();
        this.ctx.stroke();
    }
}
